var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 56,
    viewBox: "0 0 42 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11-4h64v64h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.99 50.243c-.751-.745-8.232-1.093-13.93-1.243-.004-.08.028-.226.291-.324.865-.325 5.54-.91 7.676-1.027L25.821 1.608A2 2 0 0 0 23.861 0H18.14a2 2 0 0 0-1.962 1.608l-9.55 47.75c-3.034.214-5.237.507-5.618.885C.51 50.738.1 51.763.1 53c0 1.657.672 3 1.5 3h38.8c.828 0 1.5-1.343 1.5-3 0-1.237-.41-2.261-.91-2.757zM18.38 11h5.24l1.8 9h-8.84l1.8-9zm-3.8 19h12.84l1.825 9.12h-16.49L14.58 30z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedRoad);
export default __webpack_public_path__ + "static/media/closed_road.394700182fb23da3ade79f91419b7633.svg";
export { ForwardRef as ReactComponent };